
import React from "react";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";

interface StatusBadgeProps {
  status: 'upcoming' | 'completed' | 'cancelled';
  isMobile?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, isMobile = false }) => {
  const { t } = useTranslation("common");
  
  const getStatusClasses = () => {
    switch (status) {
      case "upcoming":
        return "bg-green-500 hover:bg-green-600 text-white";
      case "completed":
        return "bg-blue-500 hover:bg-blue-600 text-white";
      case "cancelled":
        return "bg-red-500 hover:bg-red-600 text-white";
      default:
        return "";
    }
  };
  
  return (
    <Badge 
      className={`${getStatusClasses()} ${isMobile ? "text-[9px] px-1.5 py-0.5 h-4" : ""}`}
    >
      {t(status)}
    </Badge>
  );
};
